import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Drawer,
  Typography,
  Button,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { Component } from "react";
import Loading from "../../../../components/Loading";
import { Link } from "react-router-dom";
import axios from "../../../../boot/axios";
import "./index.css";

class Menu extends Component {
  constructor() {
    super();
    this.state = {
      links: [],
      loading: true,
      error: {
        show: false,
        status: 0,
      },
    };
  }

  getLinks = () => {
    this.setState({ loading: true, error: { show: false, status: 0 } });
    axios
      .get("Links")
      .then(({ data }) => {
        this.setState({ links: data.sath1, loading: false });
      })
      .catch((error) => {
        if (error.response && error.response.status) {
          this.setState({
            error: { show: true, status: error.response.status },
            loading: false,
          });
        } else {
          this.setState({
            error: { show: true, status: -1 },
            loading: false,
          });
        }
      });
  };

  sortLinks = (links = []) => {
    let newLinks = [];
    links.forEach((item, index) => {
      if (item.children && item.children.length > 0) {
        newLinks.push(
          <Accordion square key={index} className="drawer-item dropdown">
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{item.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="flex column full-width">
                {this.sortLinks(item.children)}
              </div>
            </AccordionDetails>
          </Accordion>
        );
      } else {
        const props = {
          key: index,
          className:
            "MuiPaper-root MuiAccordion-root drawer-item link MuiPaper-elevation1",
          children: item.name,
          onClick:this.props.onClose
        };
        newLinks.push(
          item.link.search("http") === -1
            ? React.createElement(Link, {
                ...props,
                to: item.link,
              })
            : React.createElement("a", {
                ...props,
                href: item.link,
                target: "_blank",
              })
        );
      }
    });
    return newLinks;
  };

  componentDidMount() {
    this.getLinks();
  }

  render() {
    const { links, loading, error } = this.state;
    return (
      <Drawer anchor="right" {...this.props}>
        {loading ? (
          <div className="loading">
            <Loading size={30} />
          </div>
        ) : error.show ? (
          <div className="error">
            <label dir="rtl">
              {error.status === -1 ? "خطا نامشخص !" : `خطای ${error.status}`}
            </label>
            <Button onClick={this.getLinks} color="primary" variant="outlined">
              تلاش مجدد
            </Button>
          </div>
        ) : (
          <div className="flex column items">{this.sortLinks(links)}</div>
        )}
      </Drawer>
    );
  }
}

export default Menu;
